<template>
    <div class="card-Section">
        <h5 class="card-Section__title">
            {{ $ml.get('cardSectionTitle') }}
        </h5>

        <button class="card-Section__btn" v-for="(card, index) in cards" :key="index" @click="$emit('cardClick', card)">
            <CardBrand :brand="card.brand.toLowerCase()" />
            <span class="card-Section__masked">
                {{ formatCardInfo(card).brand }}
                {{ $ml.get(formatCardInfo(card).typeKey) }}
                •••• {{ formatCardInfo(card).lastDigits }}
            </span>
            <img class="card-Section__chevron" src="@/assets/img/icons/arrow-down-blue.svg" alt="" tabindex="-1" />
        </button>

        <Divider />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Divider from '@/components/Divider';
	import CardBrand from '@/components/CardBrand.vue';

    export default {
        data() {
            return {};
        },

        props: {},

        components: {
            Divider,
			CardBrand,
        },

        computed: {
            ...mapGetters({
                cards: 'dataOnFile/getCards',
            })
        },

		methods: {
			formatCardInfo(card) {
				const brand = card.brand.charAt(0).toUpperCase() + card.brand.slice(1).toLowerCase();
				const typeKey = card.type.toLowerCase();
				const lastDigits = card.maskedNumber.slice(-4);
				return { brand, typeKey, lastDigits };
			}
		}
    };
</script>

<style lang='scss' scoped>
    .card-Section {
		display: flex;
		flex-direction: column;

		&__title {
			font-size: 16px;
			font-weight: 600;
			color: #2F363E;
			margin-bottom: 20px;
		}

		&__btn {
			height: 63px;
			display: flex;
			align-items: center;
			position: relative;
			border: 1.5px solid #B8C1CC;
			border-radius: 12px;
			background: transparent;
			padding: 20px 16px;
			margin-bottom: 20px;

			&:hover,
			&:focus {
				background-color: #EFF1F3;
			}
		}

		&__masked {
			font-size: 16px;
			font-weight: 500;
			color: #2F363E;
			margin-left: 12px;
		}

		&__chevron {
			width: 24px;
			height: 24px;
			position: absolute;
			top: 50%;
			right: 16px;
			transform: translateY(-50%) rotate(-90deg);
		}
	}
</style>
